import { inject, observer } from "mobx-react";
import React from "react";
import { Link } from "react-router-dom";
import { StoreContext } from "../../contexts/StoreContext";
import MaintenanceAgencyLabel from "./MaintenanceAgencyLabel";

import EntityDetailsModal from "../../modal-views/EntityDetailsModal";

@inject("previewStore", "popupStore", "detailViewStore")
@observer
export class RelatedObjectSubItem extends React.Component {
  state = {
    showVariableDetailsModal: false,
    showAll: false,
    variableToshow: null,
  };

  ShouldPopupOpen(itemType, context) {
    if (context === "null") return false;
    if (itemType === "Member" || itemType === "Combination") return true;
    return false; // by default replace current page
  }

  handleToggleVariableDetailsModal = (e, detailsItem) => {
    e?.preventDefault();
    this.setState((oldState) => ({
      ...oldState,
      showVariableDetailsModal: !oldState.showVariableDetailsModal,
      variableToshow: detailsItem,
    }));
    return false;
  };

  getTitle() {
    const { item } = this.props;
    const titleItems = [];
    const { variableToshow } = this.state;
    const { setType, setTid, clearEntityData } = this.props.previewStore;
    if (item.name) {
      titleItems.push(
        this.context === this.props.detailViewStore &&
          this.context.type === "Framework" ? (
          <Link
            onClick={(e) => {
              e.preventDefault();
              setType(item.type);
              setTid(item.tid);
            }}
            key="title-name"
            className="object-name"
            to={`/view/${item.type}/${item.tid}`}
          >
            {item.name}
          </Link>
        ) : !this.ShouldPopupOpen(item.type, this.context) ? (
          <Link
            onClick={clearEntityData}
            key="title-name"
            to={`/view/${item.type}/${item.tid}`}
            className="object-name"
          >
            {item.name}
          </Link>
        ) : (
          <Link
            onClick={(e) => {
              this.handleToggleVariableDetailsModal(e, item);
            }}
            key="title-name"
            to={`/view/${item.type}/${item.tid}`}
            className="object-name"
          >
            {item.name}
          </Link>
        )
      );
    }
    if (item.legalCode) {
      titleItems.push(
        this.context === this.props.detailViewStore &&
          this.context.type === "Framework" ? (
          <Link
            onClick={(e) => {
              e.preventDefault();
              setType(item.type);
              setTid(item.tid);
            }}
            key="title-legalCode"
            className="object-name"
            to={`/view/${item.type}/${item.tid}`}
          >
            {item.legalCode}
          </Link>
        ) : this.context === null ? (
          <Link
            onClick={clearEntityData}
            key="title-legalCode"
            to={`/view/${item.type}/${item.tid}`}
            className="object-name"
          >
            {item.legalCode}
          </Link>
        ) : (
          <Link
            onClick={(e) => {
              this.handleToggleVariableDetailsModal(e, item);
            }}
            key="title-legalCode"
            to={`/view/${item.type}/${item.tid}`}
            className="object-name"
          >
            {item.legalCode}
          </Link>
        )
      );
    }
    if (item.code) {
      if (!item.name && !item.legalCode) {
        titleItems.push(
          this.context === this.props.detailViewStore &&
            this.context.type === "Framework" ? (
            <Link
              onClick={(e) => {
                e.preventDefault();
                setType(item.type);
                setTid(item.tid);
              }}
              key="title-name"
              className="object-name"
              to={`/view/${item.type}/${item.tid}`}
            >
              {item.code}
            </Link>
          ) : (
            <Link
              onClick={clearEntityData}
              key="title-name"
              to={`/view/${item.type}/${item.tid}`}
              target={
                item.type.toLowerCase() === "cubelink" ? "_blank" : "_self"
              }
              className="object-name"
            >
              {item.code}
            </Link>
          )
        );
      }
      titleItems.push(` (${item.code}) `);
    }

    /* titleItems.push(<Label key='title-type' className='object-type' bsStyle='success'>{item.type}</Label>) */
    if (item.maintenanceAgencyId) {
      titleItems.push(
        <MaintenanceAgencyLabel
          maintenanceAgencyId={item.maintenanceAgencyId}
        ></MaintenanceAgencyLabel>
      );
    }
    titleItems.push(
      this.state.showVariableDetailsModal && (
        <StoreContext.Provider value={this.props.popupStore}>
          <EntityDetailsModal
            details={variableToshow ? variableToshow : item}
            onClose={(e) => {
              this.handleToggleVariableDetailsModal(e, item);
            }}
          />
        </StoreContext.Provider>
      )
    );
    return titleItems;
  }
  static contextType = StoreContext;
  render() {
    return <div className="related-object">{this.getTitle()}</div>;
  }
}
